import Vue from 'vue'
import VueRouter from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Home from '@/components/Home'

import Login from '@/components/Login'
import Logout from '@/components/Logout'
import Recover from '@/components/Recover'
import ResetPassword from '@/components/ResetPassword'
import Register from '@/components/Register'
import Account from '@/components/Account'
import Gdpr from '@/components/Gdpr'

import Classroom from '@/components/Classroom'
import ClassroomPremium from '@/components/ClassroomPremium'
import ClassroomPremiumSSO from '@/components/ClassroomPremiumSSO'
import ClassroomReserve from '@/components/ClassroomReserve'
import ClassroomLive from '@/components/ClassroomLive'
import CancelSeat from '@/components/CancelSeat'
import ClassroomAffidavit from '@/components/ClassroomAffidavit'
import Podcast from '@/components/Podcast'
import BlogPost from '@/components/BlogPost'
import Drilldown from '@/components/Drilldown'

import SVA from '@/components/SVA'
import Survey from '@/components/Survey'
import EvalPodcast from '@/components/EvalPodcast'
import ExamPodcast from '@/components/ExamPodcast'
import Eval from '@/components/Eval'
import Exam from '@/components/Exam'
import Done from '@/components/Done'

import Search from '@/components/Search'
import Upcoming from '@/components/Upcoming'
import Ondemand from '@/components/Ondemand'
import Premium from '@/components/Premium'
import Podcasts from '@/components/Podcasts'
import Blog from '@/components/Blog'
import Drilldowns from '@/components/Drilldowns'
import Tutorials from '@/components/Tutorials'
import Ebooks from '@/components/Ebooks'

import Seats from '@/components/Seats'
import Queue from '@/components/Queue'
import Pending from '@/components/Pending'
import Completed from '@/components/Completed'
import TutorialHistory from '@/components/TutorialHistory'

import Support from '@/components/Support'
import AboutUs from '@/components/AboutUs'
import Terms from '@/components/Terms'
import Privacy from '@/components/Privacy'

import NotFound from '@/components/NotFound'

// Test Pages
import Plyr from '@/components/Plyr'
import Plyr2 from '@/components/Plyr2'
import Plyr3 from '@/components/Plyr3'
import PlyrYoutube from '@/components/PlyrYoutube'
import Test from '@/components/Test'
import FontAwesome from '@/components/FontAwesome'
import BootstrapVue from '@/components/BootstrapVue'
import YoutubeVue from '@/components/YoutubeVue'

/* eslint-disable */

Vue.use(VueRouter)

// Put Login routes last since they have URL paramaters
// Base Url is:
// https://site.com/{studentHash}/{classHash}
// eg
// https://site.com/111-22-33/55-asdf-99

const router = new VueRouter({
  mode: 'history',
  // beforeEach: function(to, from, next) {
  //   console.log(`router`)
  //   console.log(this)
  //   if(to.meta.requiresAuth) {
  //       if (this.isLoggedIn()) {  //authUser.access_token
  //         next();
  //       }
  //       else {
  //         next({ name: 'login' });
  //       }
  //   }
  //   next();
  // },
  // isLoggedIn:  () => {  // not used!!
  //   console.log(`router -  NEVER CALLED?`)
  //   console.log(`ls: ${localStorage.getItem('id_token')}`)
  //   return (localStorage.getItem('id_token') !== null);
  // },
  routes: [
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        title: 'Free Online Dental CE | Viva Learning',
        page: '/index.asp',
        requiresAuth: false
      },
      alias: '/'
    },
    {
      path: '/search',
      name: 'Search',
      component: Search,
      props: true,
      meta: {
        title: 'Search All Content | Viva Learning',
        page: '/member/dental-webinars-podcasts.asp',
        requiresAuth: false
      }
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms,
      props: true,
      meta: {
        title: 'Terms and Conditions | Viva Learning',
        page: '/terms.asp',
        requiresAuth: false
      },
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy,
      props: true,
      meta: {
        title: 'Privacy | Viva Learning',
        page: '/privacy.asp',
        requiresAuth: false
      }
    },
    {
      path: '/aboutus',
      name: 'AboutUs',
      component: AboutUs,
      props: true,
      meta: {
        title: 'About Us | Viva Learning',
        page: '/aboutus.asp',
        requiresAuth: false
      },
      alias: '/about-us'
    },
    {
      path: '/support',
      name: 'Support',
      component: Support,
      props: true,
      meta: {
        title: 'Support | Viva Learning',
        page: '/support/support.asp',
        requiresAuth: false
      }
    },
    {
      path: '/account',
      name: 'Account',
      component: Account,
      props: true,
      meta: {
        title: 'Member Account | Viva Learning',
        page: '/member/profile.asp',
        requiresAuth: true
      }
    },
    {
      path: '/gdpr',
      name: 'Gdpr',
      component: Gdpr,
      props: true,
      meta: {
        title: 'GDPR Remove Consent | Viva Learning',
        page: '/member/gdpr',
        requiresAuth: true
      }
    },
    {
      path: '/sva/:c',
      name: 'SVA',
      component: SVA,
      props: true,
      meta: {
        title: 'Sponsored Video | Viva Learning',
        page: '/member/sva.asp',
        requiresAuth: true
      }
    },
    {
      path: '/survey/:c',
      name: 'Survey',
      component: Survey,
      props: true,
      meta: {
        title: 'Sponsored Survey | Viva Learning',
        page: '/member/survey.asp',
        requiresAuth: true
      }
    },
    {
      path: '/classroom/:c',
      name: 'Classroom',
      component: Classroom,
      props: true,
      meta: {
        title: 'Classroom - Viva Learning',
        page: '/member/classroom.asp',
        requiresAuth: false
      },
      alias: ['/on-demand-dental-ce-course/:c']  // SEO friendly alias for /classroom
    },
    {
      path: '/classroom-premium/:c',
      name: 'ClassroomPremium',
      component: ClassroomPremium,
      props: true,
      meta: {
        title: 'Premium Classroom | Viva Learning',
        page: '/member/premium.asp',
        requiresAuth: false
      },
      alias: ['/premium-dental-ce-course/:c']
    },
    {
      path: '/premium-classroom-sso/:lw',
      name: 'ClassroomPremiumSSO',
      component: ClassroomPremiumSSO,
      props: true,
      meta: {
        title: 'Premium Classroom Visit | Viva Learning',
        page: '/member/premium.asp',
        requiresAuth: true
      }
    },
    {  // use task-based aliases for analytics
      path: '/classroom-reserve/:c',
      name: 'ClassroomReserve',
      component: ClassroomReserve,
      props: true,
      meta: {
        title: 'Reserve Seat | Viva Learning',
        page: '/member/reserve.asp',
        requiresAuth: false
      },
      alias: '/reserve/:c'
    },
    {  // use task-based aliases for analytics
      path: '/classroom-live/:c',
      name: 'ClassroomLive',
      component: ClassroomLive,
      props: true,
      meta: {
        title: 'Live Dental Webinar | Viva Learning',
        page: '/member/classroomlive.asp',
        requiresAuth: true
      },
      alias: '/live/:c'
    },
    {  // use task-based aliases for analytics
      path: '/classroom-affidavit/:c',
      name: 'ClassroomAffidavit',
      component: ClassroomAffidavit,
      props: true,
      meta: {
        title: 'Confirm Webinar Attendance | Viva Learning',
        page: '/member/classliveaffadavit.asp',
        requiresAuth: true
      },
      alias: '/affidavit/:c'
    },
    {  // use task-based aliases for analytics
      path: '/cancel-seat/:code',
      name: 'CancelSeat',
      component: CancelSeat,
      props: true,
      meta: {
        title: 'Cancel Seat | Viva Learning',
        page: '/member/cancel.asp',
        requiresAuth: false
      },
      alias: ['/cancel/:code']
    },
    {
      path: '/podcast/:ps/:p?',
      name: 'Podcast',
      component: Podcast,
      props: true,
      meta: {
        title: 'Podcast Series | Viva Learning',
        page: '/member/dental-podcasts.asp',
        requiresAuth: false
      },
      alias: ['/dental-podcasts/:s']  // SEO friendly alias for /podcast
    },
    {
      path: '/blog-post/:blogId/:nolog?',
      name: 'BlogPost',
      component: BlogPost,
      props: true,
      meta: {
        title: 'Dental Blog Post | Viva Learning',
        page: '/member/dental-blog-post.asp',
        requiresAuth: false
      },
      alias: ['/dental-blog/:blogId/:nolog?'] // SEO friendly
    },
    {
      path: '/drilldown/:drilldownId/:nolog?',
      name: 'Drilldown',
      component: Drilldown,
      props: true,
      meta: {
        title: '5-Minute Drill Down Video | Viva Learning',
        page: '/member/drilldowns.asp',
        requiresAuth: false
      },
      alias: '/drill-down/:drilldownId/:nolog?',
    },
    {
      path: '/eval/:c',
      name: 'Evaluation',
      component: Eval,
      props: true,
      meta: {
        title: 'Class Evaluation | Viva Learning',
        page: '/member/evaluation.asp',
        requiresAuth: true
      }
    },
    {
      path: '/eval-podcast/:p',
      name: 'EvaluationPodcast',
      component: EvalPodcast,
      props: true,
      meta: {
        title: 'Podcast Evaluation | Viva Learning',
        page: '/member/evaluation.asp',
        requiresAuth: true
      }
    },
    {
      path: '/exam/:c',
      name: 'Exam',
      component: Exam,
      props: true,
      meta: {
        title: 'CE Exam | Viva Learning',
        page: '/member/exam.asp',
        requiresAuth: true
      }
    },
    {
      path: '/exam-podcast/:p',
      name: 'ExamPodcast',
      component: ExamPodcast,
      props: true,
      meta: {
        title: 'Podcast CE Exam | Viva Learning',
        page: '/member/exam.asp',
        requiresAuth: true
      }
    },
    {
      path: '/done/:c',
      name: 'Done',
      component: Done,
      props: true,
      meta: {
        title: 'Post Exam | Viva Learning',
        page: '/member/done.asp',
        requiresAuth: true
      }
    },
    {
      path: '/recover',
      name: 'Recover',
      component: Recover,
      meta: {
        title: 'Recover Login | Viva Learning',
        page: '/passwordResetRequest.asp',
        requiresAuth: false
      }
    },
    {
      path: '/reset/:t',
      name: 'Reset',
      component: ResetPassword,
      props: true,
      meta: {
        title: 'Reset Password | Viva Learning',
        page: '/passwordReset.asp',
        requiresAuth: false
      }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      props: true,
      meta: {
        title: 'Register Free Account | Viva Learning',
        page: '/login.asp',
        requiresAuth: false
      }
    },
    {
      path: '/webinars',
      name: 'Upcoming',
      component: Upcoming,
      meta: {
        title: 'Live Dental Webinars - Free Online CE Courses | Viva Learning',
        page: '/member/live-dental-ce-webinars.asp',
        requiresAuth: false
      },
      alias: '/upcoming'
    },
    {
      path: '/ondemand/:page?',
      name: 'Ondemand',
      component: Ondemand,
      meta: {
        title: 'On-Demand Dental Webinars - Free Online CE Courses | Viva Learning',
        page: '/member/on-demand-dental-ce-webinars.asp',
        requiresAuth: false
      },
      props: true
    },
    {
      path: '/premium/:page?',
      name: 'Premium',
      component: Premium,
      meta: {
        title: 'Premium Dental Webinars - Free Online CE Courses | Viva Learning',
        page: '/member/premium-dental-ce-courses.asp',
        requiresAuth: false
      },
      props: true
    },
    {
      path: '/podcasts/:page?',
      name: 'Podcasts',
      component: Podcasts,
      props: true,
      meta: {
        title: 'Dental Podcasts | Viva Learning',
        page: '/member/dental-podcasts.asp',
        requiresAuth: false
      }
    },
    {
      path: '/blog/:page?',
      name: 'Blog',
      component: Blog,
      props: true,
      meta: {
        title: 'Dental Blog | Viva Learning',
        page: '/member/dental-blog.asp',
        requiresAuth: false
      }
    },
    {
      path: '/drilldowns/:page?',
      name: 'Drilldowns',
      component: Drilldowns,
      props: true,
      meta: {
        title: '5-Minute Drill Downs | Viva Learning',
        page: '/member/drilldowns.asp',
        requiresAuth: false
      }
    },
    {
      path: '/seats',
      name: 'Seats',
      component: Seats,
      props: true,
      meta: {
        title: 'Reserved Seats | Viva Learning',
        page: '/member/myaccount.asp',
        requiresAuth: true
      },
      alias: '/reserved'
    },
    {
      path: '/pending/:page?',
      name: 'Pending',
      component: Pending,
      props: true,
      meta: {
        title: 'CE in Progress | Viva Learning',
        page: '/member/inprogress.asp',
        requiresAuth: true
      },
      alias: '/exams/:page?'
    },
    {
      path: '/queue/:page?',
      name: 'Queue',
      component: Queue,
      props: true,
      meta: {
        title: 'Watch Later | Viva Learning',
        page: '/member/queue.asp',
        requiresAuth: true
      }
    },
    {
      path: '/completed/:page?',
      name: 'Completed',
      component: Completed,
      meta: { requiresAuth: true },
      props: true,
      meta: {
        title: 'Completed CE | Viva Learning',
        page: '/member/completed.asp',
        requiresAuth: true
      },
      alias: '/completed-exams/:page?'
    },
    {
      path: '/tutorial-history/:page?',
      name: 'TutorialHistory',
      component: TutorialHistory,
      props: true,
      meta: {
        title: 'Product Training History | Viva Learning',
        page: '/member/viewed.asp',
        requiresAuth: true
      }
    },
    {
      path: '/tutorials/:page?',
      name: 'Tutorials',
      component: Tutorials,
      props: true,
      meta: {
        title: 'Dental Product Training | Viva Learning',
        page: '/member/dental-product-training.asp',
        requiresAuth: false
      }
    },
    {
      path: '/ebooks/:page?',
      name: 'Ebooks',
      component: Ebooks,
      props: true,
      meta: {
        title: 'Dental eBooks | Viva Learning',
        page: '/member/dental-ebooks.asp',
        requiresAuth: false
      }
    },
    {
      path: '/test',
      name: 'Test',
      component: Test,
      props: true,
      alias: '/test2'
    },
    {
      path: '/fa',
      name: 'FontAwesome',
      component: FontAwesome,
      props: true,
      alias: '/fa2'
    },
    {
      path: '/bv',
      name: 'BootstrapVue',
      component: BootstrapVue,
      props: true,
      alias: '/bv2'
    },
    {
      path: '/yt',
      name: 'YoutubeVue',
      component: YoutubeVue,
      alias: '/ytv'
    },
    {
      path: '/plyr',
      name: 'VuePlyr',
      component: Plyr,
      props: true
    },
    {
      path: '/plyr2/:ps?',
      name: 'VuePlyr2',
      component: Plyr2,
      props: true
    },
    {
      path: '/plyr3/:ps?',
      name: 'VuePlyr3',
      component: Plyr3,
      props: true
    },
    {
      path: '/plyr-youtube/:v?',
      name: 'VuePlyrYoutube',
      component: PlyrYoutube,
      props: true,
      alias: '/plyryt/:v?'
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout,
      props: true,
      meta: {
        title: 'Logout | Viva Learning',
        page: '/logout.asp',
        requiresAuth: false
      }
    },
    {
      path: '/hello',
      name: 'HelloWorld',
      component: HelloWorld,
      meta: {
        title: 'Hello World',
        page: '/helloworld.asp',
        requiresAuth: false
      }
    },
    {
      path: '/login/:s?',
      name: 'Login',
      component: Login,
      props: true,
      meta: {
        title: 'Login | Viva Learning',
        page: '/login.asp',
        requiresAuth: false
      }
    },
    {  // 404 page - last
      path: '*',
      name: 'NotFound',
      component: NotFound,
      props: true,
      meta: {
        title: '404 | Viva Learning',
        page: '/404.asp',
        requiresAuth: false
      },
      alias: '/404'
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    // document.getElementById('app').scrollIntoView();
    if (savedPosition) {
      // when forward and back are used
      return savedPosition
    } else {
      // click to new route goes to top of page.
      return { x: 0, y: 0 }
    }
  }
})

// scrollBehavior - scroll to top on route.
// https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
// https://router.vuejs.org/guide/advanced/scroll-behavior.html

router.beforeEach((to, from, next) => {
  // console.log(`router to: ${to.path}`)
  // console.log(to)
  // console.log(`router from`)
  // console.log(from)

  if (to.meta.requiresAuth && !isLoggedIn()) {
    // console.log(`to.fullPath: ${to.fullPath}`)
    next({ path: '/login', query: { rurl: to.fullPath } })
  }
  else {
    next()
  }

  function isLoggedIn() {   // internal function
    // console.log(`isLoggedIn internal...`)
    // console.log(`ls: ${localStorage.getItem('id_token')}`)
    return (localStorage.getItem('id_token') && true);
  }
})

const DEFAULT_TITLE = 'DEFAULT VIVA TITLE'
const DEFAULT_PAGE = '/index.asp'

// Set page title and do google analytics.
// https://serversideup.net/google-analytics-vue-router-single-page-application/
// Pre-GA4
// https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#content
// https://stackoverflow.com/questions/51639850/how-to-change-page-titles-when-using-vue-router
// GA4
// https://peterdaugaardrasmussen.com/2022/08/13/gtag-stop-gtag-from-sending-initiali-pageview/
// https://developers.google.com/analytics/devguides/collection/ga4/views?client_type=gtag
router.afterEach((to, from) => {
  // console.log(`Router.AfterEach - ${to.meta.title} / ${to.meta.page}`)

  // Register page view - GA4 style
  // meta/page is relative link to page on VP.  (GA already knows based URL)
  gtag('event', 'page_view', {
    page_title: to.meta.title || DEFAULT_TITLE,
    page_location: to.meta.page || DEFAULT_PAGE,    // window.location.href,  (sending desktop page value (correct?))
    page_path: window.location.pathname,
    send_to: 'G-Z7VS4H5ZHN'
  });

  // Add canonical link for AI search engines that process client side rendered pages.
  let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.rel = 'canonical';
    document.head.appendChild(canonical);
  }
  canonical.href = Vue.prototype.$desktopUrl + to.path;

  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  })
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js